<template>
  <div class="box" ref="box">
    <div class="avatar" ref="avatar">
      <img :src="imgurl" draggable="false" style="width: 100%;">
    </div>
  </div>
</template>

<script>
export default {
  name: 'imgZoom',
  data () {
    return {
      x: null,
      y: null,
      DELTA: 1.1,
      oDiv: null,
      oBox: null,
      imgurl: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.oDiv = this.$refs.avatar
      this.oBox = this.$refs.box
      this.init()
    })
  },
  methods: {
    init () {
      // 禁止选中文字/图片
      document.addEventListener('selectstart', e => { e.preventDefault() })
      // 鼠标按下事件
      this.oDiv.addEventListener('mousedown', this.mouseDown)
      // 图片缩放
      this.oDiv.addEventListener('wheel', this.zoom)
    },
    // 鼠标按下 获取位置并添加事件监听
    mouseDown (e) {
      let transf = this.getTransform(this.oDiv)
      this.x = e.clientX - transf.transX // 图片初始位置
      this.y = e.clientY - transf.transY // 图片初始位置
      document.addEventListener('mousemove', this.mouseMove)
      document.addEventListener('mouseup', this.mouseUp)
    },
    // 鼠标拖动 更新transform
    mouseMove (e) {
      let multiple = this.getTransform(this.oDiv).multiple
      let moveX = e.clientX - this.x // x向移动距离
      let moveY = e.clientY - this.y // y向移动距离
      let newTransf = this.limitBorder(this.oDiv, this.oBox, moveX, moveY, multiple)
      this.oDiv.style.transform = `matrix(${multiple}, 0, 0, ${multiple}, ${newTransf.transX}, ${newTransf.transY})`
    },
    mouseUp () {
      document.removeEventListener('mousemove', this.mouseMove)
      document.removeEventListener('mouseup', this.mouseUp)
    },
    // 鼠标滚轮缩放 更新transform
    zoom (e) {
      let transf = this.getTransform(this.oDiv)
      if (e.deltaY < 0) {
        transf.multiple *= this.DELTA // 放大DELTA倍
      } else {
        transf.multiple /= this.DELTA // 缩小DELTA倍
      }
      let newTransf = this.limitBorder(this.oDiv, this.oBox, transf.transX, transf.transY, transf.multiple)
      this.oDiv.style.transform = `matrix(${transf.multiple}, 0, 0, ${transf.multiple}, ${newTransf.transX}, ${newTransf.transY})`
    },
    setZoom () {
      // 初始化图片比例
      this.$refs.avatar.style.transform = `matrix(1, 0, 0, 1, 0, 0)`
    },
    /**
     * 通过getComputedStyle获取transform矩阵 并用split分割
     * 如 oDiv 的 transform: translate(100, 100);
     * getComputedStyle可以取到"matrix(1, 0, 0, 1, 100, 100)"
     * 当transform属性没有旋转rotate和拉伸skew时
     * metrix的第1, 4, 5, 6个参数为 x方向倍数, y方向倍数, x方向偏移量, y方向偏移量
     * 再分别利用 字符串分割 取到对应参数
     */
    getTransform (DOM) {
      let arr = getComputedStyle(DOM).transform.split(',')
      return {
        transX: isNaN(+arr[arr.length - 2]) ? 0 : +arr[arr.length - 2], // 获取translateX
        transY: isNaN(+arr[arr.length - 1].split(')')[0]) ? 0 : +arr[arr.length - 1].split(')')[0], // 获取translateX
        multiple: +arr[3] // 获取图片缩放比例
      }
    },
    /**
     * 获取边框限制的transform的x, y偏移量
     * innerDOM: 内盒子DOM
     * outerDOM: 边框盒子DOM
     * moveX: 盒子的x移动距离
     * moveY: 盒子的y移动距离
     */
    limitBorder (innerDOM, outerDOM, moveX, moveY, multiple) {
      // let { clientWidth: innerWidth, clientHeight: innerHeight, offsetLeft: innerLeft, offsetTop: innerTop } = innerDOM
      // let { clientWidth: outerWidth, clientHeight: outerHeight } = outerDOM
      // // 放大的图片超出box时 图片最多拖动到与边框对齐
      // if (innerWidth * multiple > outerWidth || innerHeight * multiple > outerHeight) {
      //   if (innerWidth * multiple > outerWidth && innerWidth * multiple > outerHeight) {
      //     transX = Math.min(Math.max(moveX, outerWidth - innerWidth * (multiple + 1) / 2 - innerLeft), -innerLeft + innerWidth * (multiple - 1) / 2)
      //     transY = Math.min(Math.max(moveY, outerHeight - innerHeight * (multiple + 1) / 2 - innerTop), -innerTop + innerHeight * (multiple - 1) / 2)
      //   } else if (innerWidth * multiple > outerWidth && !(innerWidth * multiple > outerHeight)) {
      //     transX = Math.min(Math.max(moveX, outerWidth - innerWidth * (multiple + 1) / 2 - innerLeft), -innerLeft + innerWidth * (multiple - 1) / 2)
      //     transY = Math.max(Math.min(moveY, outerHeight - innerHeight * (multiple + 1) / 2 - innerTop), -innerTop + innerHeight * (multiple - 1) / 2)
      //   } else if (!(innerWidth * multiple > outerWidth) && innerWidth * multiple > outerHeight) {
      //     transX = Math.max(Math.min(moveX, outerWidth - innerWidth * (multiple + 1) / 2 - innerLeft), -innerLeft + innerWidth * (multiple - 1) / 2)
      //     transY = Math.min(Math.max(moveY, outerHeight - innerHeight * (multiple + 1) / 2 - innerTop), -innerTop + innerHeight * (multiple - 1) / 2)
      //   }
      // } else {
      //   // 图片小于box大小时 图片不能拖出边框
      //   transX = Math.max(Math.min(moveX, outerWidth - innerWidth * (multiple + 1) / 2 - innerLeft), -innerLeft + innerWidth * (multiple - 1) / 2)
      //   transY = Math.max(Math.min(moveY, outerHeight - innerHeight * (multiple + 1) / 2 - innerTop), -innerTop + innerHeight * (multiple - 1) / 2)
      // }
      // 去除边框限制
      let transX = moveX
      let transY = moveY
      return { transX, transY }
    }
  }
}
</script>

<style scoped>
  .box {
    position: relative;
    /* width: 100vw;
    height: 100vh; */
    overflow: hidden;
  }

  .avatar {
    /* width: 100vw;
    height: 100vh; */
    width: 100%;
    left: 50px;
    top: 50px;
    right: 50px;
    bottom: 50px;
    transform: translate(0px, 0px);
    overflow: hidden;
  }

  /*.avatar img {*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/common/imgZoom.vue